// status: play, playing, grading, graded
export const DECK = [
  {
    question: "O que é JSX?",
    answer: "Uma extensão da linguagem JavaScript",
    status: "play",
    score: null
  },
  {
    question: "O React é __",
    answer: "Uma biblioteca JavaScript para construção de interfaces",
    status: "play",
    score: null
  },
  {
    question: "Componentes devem iniciar com __",
    answer: "Letra maiúscula",
    status: "play",
    score: null
  },
  {
    question: "Podemos colocar __ dentro do JSX",
    answer: "expressões",
    status: "play",
    score: null
  },
  {
    question: "O ReactDOM nos ajuda __",
    answer: "Interagindo com a DOM para colocar componentes React na mesma",
    status: "play",
    score: null
  },
  {
    question: "Usamos o npm para __",
    answer: "Gerenciar os pacotes necessários e suas dependências",
    status: "play",
    score: null
  },
  {
    question: "Usamos props para __",
    answer: "Passar diferentes informações para componentes",
    status: "play",
    score: null
  },
  {
    question: "Usamos estado (state) para __",
    answer:
      "Dizer para o React quais informações quando atualizadas devem renderizar a tela novamente",
    status: "play",
    score: null
  }
];
